import React from 'react';
import { IAction } from './interfaces';

export const Action: React.FC<IAction> = () => null;
